<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';

const props = defineProps({
  task: { type: Object, required: true },
});

const emit = defineEmits(['updated']);

const store = useStore();
const { t } = useI18n();
const watching = computed(() => Boolean(props.task.watching));

const toggle = async () => {
  emit(
    'updated',
    await store.dispatch('tasks/setWatching', {
      id: props.task.id,
      watching: !watching.value,
    })
  );
};
</script>

<template>
  <button
    class="flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg shrink-0"
    :class="
      watching
        ? 'bg-n-brand/10 text-n-brand'
        : 'bg-n-alpha-2 text-n-slate-11 hover:bg-n-alpha-3'
    "
    :title="t('TASKS.CARD.WATCH_HINT')"
    @click="toggle"
  >
    <span
      :class="watching ? 'i-lucide-eye' : 'i-lucide-eye-off'"
      class="size-3.5"
    />
    {{ watching ? t('TASKS.CARD.WATCHING') : t('TASKS.CARD.WATCH') }}
  </button>
</template>
